// src/money.ts
import { Big } from "big.js";

// src/currencies.ts
var CURRENCIES = {
  AED: { code: "AED", base: 10, exponent: 2 },
  AFN: { code: "AFN", base: 10, exponent: 2 },
  ALL: { code: "ALL", base: 10, exponent: 2 },
  AMD: { code: "AMD", base: 10, exponent: 2 },
  ANG: { code: "ANG", base: 10, exponent: 2 },
  AOA: { code: "AOA", base: 10, exponent: 2 },
  ARS: { code: "ARS", base: 10, exponent: 2 },
  AUD: { code: "AUD", base: 10, exponent: 2 },
  AWG: { code: "AWG", base: 10, exponent: 2 },
  AZN: { code: "AZN", base: 10, exponent: 2 },
  BAM: { code: "BAM", base: 10, exponent: 2 },
  BBD: { code: "BBD", base: 10, exponent: 2 },
  BDT: { code: "BDT", base: 10, exponent: 2 },
  BGN: { code: "BGN", base: 10, exponent: 2 },
  BHD: { code: "BHD", base: 10, exponent: 3 },
  BIF: { code: "BIF", base: 10, exponent: 0 },
  BMD: { code: "BMD", base: 10, exponent: 2 },
  BND: { code: "BND", base: 10, exponent: 2 },
  BOB: { code: "BOB", base: 10, exponent: 2 },
  BOV: { code: "BOV", base: 10, exponent: 2 },
  BRL: { code: "BRL", base: 10, exponent: 2 },
  BSD: { code: "BSD", base: 10, exponent: 2 },
  BTN: { code: "BTN", base: 10, exponent: 2 },
  BWP: { code: "BWP", base: 10, exponent: 2 },
  BYN: { code: "BYN", base: 10, exponent: 2 },
  BZD: { code: "BZD", base: 10, exponent: 2 },
  CAD: { code: "CAD", base: 10, exponent: 2 },
  CDF: { code: "CDF", base: 10, exponent: 2 },
  CHE: { code: "CHE", base: 10, exponent: 2 },
  CHF: { code: "CHF", base: 10, exponent: 2 },
  CHW: { code: "CHW", base: 10, exponent: 2 },
  CLF: { code: "CLF", base: 10, exponent: 4 },
  CLP: { code: "CLP", base: 10, exponent: 0 },
  CNY: { code: "CNY", base: 10, exponent: 2 },
  COP: { code: "COP", base: 10, exponent: 2 },
  COU: { code: "COU", base: 10, exponent: 2 },
  CRC: { code: "CRC", base: 10, exponent: 2 },
  CUC: { code: "CUC", base: 10, exponent: 2 },
  CUP: { code: "CUP", base: 10, exponent: 2 },
  CVE: { code: "CVE", base: 10, exponent: 2 },
  CZK: { code: "CZK", base: 10, exponent: 2 },
  DJF: { code: "DJF", base: 10, exponent: 0 },
  DKK: { code: "DKK", base: 10, exponent: 2 },
  DOP: { code: "DOP", base: 10, exponent: 2 },
  DZD: { code: "DZD", base: 10, exponent: 2 },
  EGP: { code: "EGP", base: 10, exponent: 2 },
  ERN: { code: "ERN", base: 10, exponent: 2 },
  ETB: { code: "ETB", base: 10, exponent: 2 },
  EUR: { code: "EUR", base: 10, exponent: 2 },
  FJD: { code: "FJD", base: 10, exponent: 2 },
  FKP: { code: "FKP", base: 10, exponent: 2 },
  GBP: { code: "GBP", base: 10, exponent: 2 },
  GEL: { code: "GEL", base: 10, exponent: 2 },
  GHS: { code: "GHS", base: 10, exponent: 2 },
  GIP: { code: "GIP", base: 10, exponent: 2 },
  GMD: { code: "GMD", base: 10, exponent: 2 },
  GNF: { code: "GNF", base: 10, exponent: 0 },
  GTQ: { code: "GTQ", base: 10, exponent: 2 },
  GYD: { code: "GYD", base: 10, exponent: 2 },
  HKD: { code: "HKD", base: 10, exponent: 2 },
  HNL: { code: "HNL", base: 10, exponent: 2 },
  HRK: { code: "HRK", base: 10, exponent: 2 },
  HTG: { code: "HTG", base: 10, exponent: 2 },
  HUF: { code: "HUF", base: 10, exponent: 2 },
  IDR: { code: "IDR", base: 10, exponent: 2 },
  ILS: { code: "ILS", base: 10, exponent: 2 },
  INR: { code: "INR", base: 10, exponent: 2 },
  IQD: { code: "IQD", base: 10, exponent: 3 },
  IRR: { code: "IRR", base: 10, exponent: 2 },
  ISK: { code: "ISK", base: 10, exponent: 0 },
  JMD: { code: "JMD", base: 10, exponent: 2 },
  JOD: { code: "JOD", base: 10, exponent: 3 },
  JPY: { code: "JPY", base: 10, exponent: 0 },
  KES: { code: "KES", base: 10, exponent: 2 },
  KGS: { code: "KGS", base: 10, exponent: 2 },
  KHR: { code: "KHR", base: 10, exponent: 2 },
  KMF: { code: "KMF", base: 10, exponent: 0 },
  KPW: { code: "KPW", base: 10, exponent: 2 },
  KRW: { code: "KRW", base: 10, exponent: 0 },
  KWD: { code: "KWD", base: 10, exponent: 3 },
  KYD: { code: "KYD", base: 10, exponent: 2 },
  KZT: { code: "KZT", base: 10, exponent: 2 },
  LAK: { code: "LAK", base: 10, exponent: 2 },
  LBP: { code: "LBP", base: 10, exponent: 2 },
  LKR: { code: "LKR", base: 10, exponent: 2 },
  LRD: { code: "LRD", base: 10, exponent: 2 },
  LSL: { code: "LSL", base: 10, exponent: 2 },
  LYD: { code: "LYD", base: 10, exponent: 3 },
  MAD: { code: "MAD", base: 10, exponent: 2 },
  MDL: { code: "MDL", base: 10, exponent: 2 },
  MGA: { code: "MGA", base: 5, exponent: 1 },
  MKD: { code: "MKD", base: 10, exponent: 2 },
  MMK: { code: "MMK", base: 10, exponent: 2 },
  MNT: { code: "MNT", base: 10, exponent: 2 },
  MOP: { code: "MOP", base: 10, exponent: 2 },
  MRU: { code: "MRU", base: 5, exponent: 1 },
  MUR: { code: "MUR", base: 10, exponent: 2 },
  MVR: { code: "MVR", base: 10, exponent: 2 },
  MWK: { code: "MWK", base: 10, exponent: 2 },
  MXN: { code: "MXN", base: 10, exponent: 2 },
  MXV: { code: "MXV", base: 10, exponent: 2 },
  MYR: { code: "MYR", base: 10, exponent: 2 },
  MZN: { code: "MZN", base: 10, exponent: 2 },
  NAD: { code: "NAD", base: 10, exponent: 2 },
  NGN: { code: "NGN", base: 10, exponent: 2 },
  NIO: { code: "NIO", base: 10, exponent: 2 },
  NOK: { code: "NOK", base: 10, exponent: 2 },
  NPR: { code: "NPR", base: 10, exponent: 2 },
  NZD: { code: "NZD", base: 10, exponent: 2 },
  OMR: { code: "OMR", base: 10, exponent: 3 },
  PAB: { code: "PAB", base: 10, exponent: 2 },
  PEN: { code: "PEN", base: 10, exponent: 2 },
  PGK: { code: "PGK", base: 10, exponent: 2 },
  PHP: { code: "PHP", base: 10, exponent: 2 },
  PKR: { code: "PKR", base: 10, exponent: 2 },
  PLN: { code: "PLN", base: 10, exponent: 2 },
  PYG: { code: "PYG", base: 10, exponent: 0 },
  QAR: { code: "QAR", base: 10, exponent: 2 },
  RON: { code: "RON", base: 10, exponent: 2 },
  RSD: { code: "RSD", base: 10, exponent: 2 },
  RUB: { code: "RUB", base: 10, exponent: 2 },
  RWF: { code: "RWF", base: 10, exponent: 0 },
  SAR: { code: "SAR", base: 10, exponent: 2 },
  SBD: { code: "SBD", base: 10, exponent: 2 },
  SCR: { code: "SCR", base: 10, exponent: 2 },
  SDG: { code: "SDG", base: 10, exponent: 2 },
  SEK: { code: "SEK", base: 10, exponent: 2 },
  SGD: { code: "SGD", base: 10, exponent: 2 },
  SHP: { code: "SHP", base: 10, exponent: 2 },
  SLL: { code: "SLL", base: 10, exponent: 2 },
  SOS: { code: "SOS", base: 10, exponent: 2 },
  SRD: { code: "SRD", base: 10, exponent: 2 },
  SSP: { code: "SSP", base: 10, exponent: 2 },
  STN: { code: "STN", base: 10, exponent: 2 },
  SVC: { code: "SVC", base: 10, exponent: 2 },
  SYP: { code: "SYP", base: 10, exponent: 2 },
  SZL: { code: "SZL", base: 10, exponent: 2 },
  THB: { code: "THB", base: 10, exponent: 2 },
  TJS: { code: "TJS", base: 10, exponent: 2 },
  TMT: { code: "TMT", base: 10, exponent: 2 },
  TND: { code: "TND", base: 10, exponent: 3 },
  TOP: { code: "TOP", base: 10, exponent: 2 },
  TRY: { code: "TRY", base: 10, exponent: 2 },
  TTD: { code: "TTD", base: 10, exponent: 2 },
  TWD: { code: "TWD", base: 10, exponent: 2 },
  TZS: { code: "TZS", base: 10, exponent: 2 },
  UAH: { code: "UAH", base: 10, exponent: 2 },
  UGX: { code: "UGX", base: 10, exponent: 0 },
  USD: { code: "USD", base: 10, exponent: 2 },
  USN: { code: "USN", base: 10, exponent: 2 },
  UYI: { code: "UYI", base: 10, exponent: 0 },
  UYU: { code: "UYU", base: 10, exponent: 2 },
  UYW: { code: "UYW", base: 10, exponent: 4 },
  UZS: { code: "UZS", base: 10, exponent: 2 },
  VES: { code: "VES", base: 10, exponent: 2 },
  VND: { code: "VND", base: 10, exponent: 0 },
  VUV: { code: "VUV", base: 10, exponent: 0 },
  WST: { code: "WST", base: 10, exponent: 2 },
  XAF: { code: "XAF", base: 10, exponent: 0 },
  XCD: { code: "XCD", base: 10, exponent: 2 },
  XOF: { code: "XOF", base: 10, exponent: 0 },
  XPF: { code: "XPF", base: 10, exponent: 0 },
  YER: { code: "YER", base: 10, exponent: 2 },
  ZAR: { code: "ZAR", base: 10, exponent: 2 },
  ZMW: { code: "ZMW", base: 10, exponent: 2 },
  ZWL: { code: "ZWL", base: 10, exponent: 2 }
};

// src/money.ts
var defaultFormatingOptions = (options) => ({
  currency: options.currency,
  minimumFractionDigits: options.exponent,
  maximumFractionDigits: options.exponent
});
var DEFAULT_EXPONENT = 2;
var DEFAULT_LOCALE = "en-US";
var _Money = class _Money {
  /**
   * Creates a new Money instance.
   * @param amount Amount in chosen unit (default is base)
   * @param currency Currency code (e.g. USD)
   * @param options
   * @see {@link fromBaseUnit} for convenience method to create a Money instance from a base unit amount.
   * @see {@link fromNaturalUnit} for convenience method to create a Money instance from a natural unit amount.
   * */
  constructor(amount, currency, options) {
    this.plus = this.add;
    this.sub = this.subtract;
    this.minus = this.subtract;
    this.mul = this.times;
    const currencyCode = getCurrencyDefinition(currency)?.code;
    if (!currencyCode)
      throw new Error(`Invalid / Not supported currency: ${currency}`);
    this._options = {
      accepts: "base",
      ...options
    };
    this._currency = currencyCode;
    this._exponent = CURRENCIES[this._currency].exponent;
    try {
      this._amount = options?.accepts === "natural" ? new Big(amount).times(new Big(10).pow(this._exponent)) : new Big(amount);
    } catch {
      this._amount = new Big(0);
    }
    this._roundMode = this._currency === "USD" ? Big.roundHalfUp : Big.roundHalfEven;
    this._numberFormatter = new Intl.NumberFormat(_Money.locale, _Money.formattingOptions(this));
  }
  /**
   * Creates a new Money instance from a base unit amount.
   * Accepts a base unit amount by default in all operations, in order to change this behavior, use `{ accepts: 'natural' }` in the options.
   * @param amount Amount in base unit (e.g. cents for USD)
   * @param currency Currency code (e.g. USD)
   * @param options
   * */
  static fromBaseUnit(amount, currency, options) {
    const exponent = getCurrencyDefinition(currency)?.exponent ?? DEFAULT_EXPONENT;
    return new _Money(getAmountForCtor({ from: "base", to: options?.accepts, amount, exponent }), currency, options);
  }
  /**
   * Creates a new Money instance from a natural unit amount.
   * Accepts a natural unit amount by default in all operations, in order to change this behavior, use `{ accepts: 'base' }` in the options.
   * @param amount Amount in natural unit (e.g. dollars for USD)
   * @param currency Currency code (e.g. USD)
   * @param options
   * */
  static fromNaturalUnit(amount, currency, options) {
    const exponent = getCurrencyDefinition(currency)?.exponent ?? DEFAULT_EXPONENT;
    const accepts = options?.accepts ?? "natural";
    return new _Money(getAmountForCtor({ from: "natural", to: accepts, amount, exponent }), currency, {
      ...options,
      accepts
    });
  }
  /**
   * Get the underlying amount in base unit, not rounded or truncated.
   **/
  get amount() {
    return this._amount;
  }
  get currency() {
    return this._currency;
  }
  /**
   * Get the exponent of the currency.
   * For example, USD has an exponent of 2, so 1 USD = 100 cents.
   * */
  get exponent() {
    return this._exponent;
  }
  /**
   * Get the unit which this money instance accepts.
   * */
  get accepts() {
    return this._options.accepts;
  }
  /**
   * Set the unit which this money instance accepts.
   * */
  set accepts(accepts) {
    this._options.accepts = accepts;
  }
  /**
   * Get the amount of this instance in natural unit.
   * @param rm Rounding mode.
   * */
  toNaturalUnit(rm) {
    return this._amount.div(new Big(10).pow(this._exponent)).round(this._exponent, rm || this._roundMode).toNumber();
  }
  /**
   * Get the amount of this instance in base unit.
   * @param rm Rounding mode.
   * */
  toBaseUnit(rm) {
    return this._amount.round(0, rm || this._roundMode).toNumber();
  }
  /**
   * Format the amount to a string using the current global formatting options or a provided prop.
   */
  toFormat(options, rm) {
    const formatter = options ? new Intl.NumberFormat(_Money.locale, {
      ..._Money.formattingOptions(this),
      ...typeof options === "function" ? options(this) : options
    }) : this._numberFormatter;
    return formatter.format(this.toNaturalUnit(rm));
  }
  toString(rm) {
    return new Big(this.toNaturalUnit(rm)).toString();
  }
  /**
   * Convert this instance to another currency.
   * @param toCurrency Currency code to convert to.
   * @param usdToForeignRate Exchange rate from USD to the foreign currency.
   * */
  convert(toCurrency, usdToForeignRate) {
    if (this.currency === toCurrency)
      return this;
    if (this.currency !== "USD" && toCurrency !== "USD")
      throw new Error("Conversion must be from USD to foreign currency or vice versa");
    const exponent = getCurrencyDefinition(toCurrency)?.exponent ?? DEFAULT_EXPONENT;
    if (toCurrency === "USD") {
      const convertedAmountInBase2 = this._amount.div(usdToForeignRate);
      return new _Money(
        getAmountForCtor({ from: "base", to: this._options.accepts, amount: convertedAmountInBase2, exponent }),
        toCurrency,
        this._options
      );
    }
    const convertedAmountInBase = this._amount.times(usdToForeignRate);
    return new _Money(
      getAmountForCtor({ from: "base", to: this._options.accepts, amount: convertedAmountInBase, exponent }),
      toCurrency,
      this._options
    );
  }
  /**
   * Returns a new Money instance by adding the provided amounts to the current instance's amount.
   * */
  add(amount) {
    const amounts = getArithmeticInputArray(amount);
    this.verifySameCurrency(amounts);
    const sum = amounts.reduce((acc, cur) => acc.plus(this.getArithmeticValue(cur)), this._amount);
    return new _Money(this.getArithmeticAmountForCtor(sum), this._currency, this._options);
  }
  /**
   * Returns a new Money instance by subtracting the provided amounts from the current instance's amount.
   * */
  subtract(amount) {
    const amounts = getArithmeticInputArray(amount);
    this.verifySameCurrency(amounts);
    const difference = amounts.reduce((acc, cur) => acc.minus(this.getArithmeticValue(cur)), this._amount);
    return new _Money(this.getArithmeticAmountForCtor(difference), this._currency, this._options);
  }
  /**
   * Returns a new Money instance by dividing the current instance's amount by the provided amount.
   * */
  div(amount) {
    return new _Money(this.getArithmeticAmountForCtor(this._amount.div(amount)), this._currency, this._options);
  }
  /**
   * Returns a new Money instance by multiplying the current instance's amount by the provided amount.
   * */
  times(amount) {
    return new _Money(this.getArithmeticAmountForCtor(this._amount.times(amount)), this._currency, this._options);
  }
  /**
   * Returns true if the provided Money instance has the same currency as this instance.
   * */
  hasSameCurrency(money) {
    return this.currency === money.currency;
  }
  /**
   * Returns true if the provided Money instance has the same amount as this instance.
   * */
  hasSameAmount(money) {
    return this._amount.eq(money.amount);
  }
  /**
   * Compares this instance to an amount or another Money instance.
   * In case of a Money instance, the currency must be the same.
   * */
  eq(amount) {
    const sameCurrency = amount instanceof _Money ? this.currency === amount.currency : true;
    return sameCurrency && this._amount.eq(this.getArithmeticValue(amount));
  }
  /**
   * Checks if this instance is greater than the provided amount or Money instance.
   * In case of a Money instance, the currency must be the same.
   * */
  gt(amount) {
    this.verifySameCurrency([amount]);
    return this._amount.gt(this.getArithmeticValue(amount));
  }
  /**
   * Checks if this instance is greater than or equal to the provided amount or Money instance.
   * In case of a Money instance, the currency must be the same.
   * */
  gte(amount) {
    this.verifySameCurrency([amount]);
    return this._amount.gte(this.getArithmeticValue(amount));
  }
  /**
   * Checks if this instance is lower than the provided amount or Money instance.
   * In case of a Money instance, the currency must be the same.
   * */
  lt(amount) {
    this.verifySameCurrency([amount]);
    return this._amount.lt(this.getArithmeticValue(amount));
  }
  /**
   * Checks if this instance is lower than or equal to the provided amount or Money instance.
   * In case of a Money instance, the currency must be the same.
   * */
  lte(amount) {
    this.verifySameCurrency([amount]);
    return this._amount.lte(this.getArithmeticValue(amount));
  }
  /**
   * Returns a new Money instance with the amount negated.
   * */
  neg() {
    return new _Money(this.getArithmeticAmountForCtor(this._amount.neg()), this._currency, this._options);
  }
  verifySameCurrency(amounts) {
    amounts.forEach((amount) => {
      if (amount instanceof _Money && this.currency !== amount.currency) {
        throw new Error("Cannot operate on money of different currencies");
      }
    });
  }
  getArithmeticValue(value) {
    if (value instanceof _Money) {
      return value.amount;
    }
    if (this._options.accepts === "natural") {
      return new Big(value).times(new Big(10).pow(this._exponent));
    }
    return value;
  }
  getArithmeticAmountForCtor(amount) {
    return getAmountForCtor({ from: "base", to: this._options.accepts, amount, exponent: this._exponent });
  }
};
_Money.locale = DEFAULT_LOCALE;
_Money.formattingOptions = defaultFormatingOptions;
_Money.roundDown = Big.roundDown;
_Money.roundHalfUp = Big.roundHalfUp;
_Money.roundHalfEven = Big.roundHalfEven;
_Money.roundUp = Big.roundUp;
var Money = _Money;
var getArithmeticInputArray = (amounts) => {
  return Array.isArray(amounts) ? amounts : [amounts];
};
var getAmountForCtor = ({
  amount,
  exponent,
  from = "base",
  to = "base"
}) => {
  if (from === "base" && to === "natural") {
    return new Big(amount).div(new Big(10).pow(exponent));
  }
  if (from === "natural" && to === "base") {
    return new Big(amount).times(new Big(10).pow(exponent));
  }
  return amount;
};
var getCurrencyDefinition = (currency) => {
  return CURRENCIES[currency.trim().toUpperCase()];
};
export {
  Money
};
//# sourceMappingURL=index.mjs.map